export default {
  nav: {
    features: '功能特点',
    howItWorks: '使用流程',
    download: '下载应用'
  },
  hint: {
    openInBrowser: '请在浏览器中打开'
  },
  hero: {
    headlinePrefix: '记录',
    headlineSuffix: '赛场点滴',
    subheadline: '专业数据 • 自动洞察 • 决胜策略',
    startNow: '立即开始',
    getApp: '下载应用',
    explore: '探索功能',
    learnMore: '了解更多'
  },
  features: {
    titlePrefix: '智能',
    titleSuffix: '记录',
    item1: {
      title: '事件驱动逻辑',
      desc: '记录动作，而不只是数字。输入"投篮命中"，我们会自动处理得分、助攻和命中率。'
    },
    item2: {
      title: '智能提示',
      desc: '投篮未中？应用会立即提示篮板球归属。抢断？它会询问谁丢失了球权。不错过任何细节。'
    },
    item3: {
      title: '可视化投篮图',
      desc: '精确追踪投篮位置。为每位球员生成专业的热力图和效率报告。'
    }
  },
  workflow: {
    titlePrefix: '工作流',
    titleSuffix: '简化',
    step1: {
      title: '快速设置',
      desc: '几秒钟内创建球队并添加球员。配置比赛规则以完美适应您的联赛。'
    },
    step2: {
      title: '实时追踪',
      desc: '点击即可记录事件。我们的直观界面无缝处理犯规和换人等复杂场景。'
    },
    step3: {
      title: '即时洞察',
      desc: '获取实时数据统计和赛后报告。导出详细的图片与团队分享。'
    }
  },
  download: {
    titlePrefix: '准备好',
    titleSuffix: '开始了吗？',
    desc: '加入成千上万使用 StatPoint 提升比赛水平的教练和球员行列。',
    button: '下载应用',
    learnMore: '了解更多'
  }
}
